/// <reference path="../../typings/tsd.d.ts" /> 
/// <reference path="../../typings/linq/linq.d.ts" />
module warsApp.models {

  declare var editableWebPageModelSelf: EditableWebPageModel;

  export class EditableWebPageModel {

    pages: Wars.Domain.Model.Dtos.ContentPageDto[];
    editableContentPageDto: Wars.Domain.Model.Dtos.EditableContentPageDto;
    activeProcessTypes: Wars.Domain.Model.ProcessType[];
    editProduction: boolean = false;
    selectableProcessTypes: any = [];
    showTinyMce: boolean = false;
    tinyMceOptions: any;

    constructor(
      private contentPageId: string,
      private contentPageService: warsApp.services.ContentPageService,
      private editableContentPageService: warsApp.services.EditableContentPageService,
      private processTypeService: services.ProcessTypeService,
      private modalService: any) {
      editableWebPageModelSelf = this;
      editableWebPageModelSelf.editableContentPageService.getEditiableContentPage(editableWebPageModelSelf.contentPageId)
        .then((editableContentPageDto) => {
          editableWebPageModelSelf.editableContentPageDto = editableContentPageDto;
        });
      editableWebPageModelSelf.processTypeService.getActiveProcessTypesNonBreeze()
        .then((processTypes) => {
          processTypes.forEach(processType => {
            var pt = "";
            if (processType.type === 1 || processType.type === 3) {
              pt = "/Process";
            } else if (processType.type === 2) {
              pt = "/ReportProcess";
            }
            editableWebPageModelSelf.selectableProcessTypes.push({
              title: processType.name,
              value: "#/ProcessType/" + processType.id + pt
            });
            editableWebPageModelSelf.showTinyMce = true;
            editableWebPageModelSelf.tinyMceOptions = {
              entity_encoding: "raw",
              //extended_valid_elements: "script[src|type|language]",
              valid_elements: "@[id|class|style|title|dir<ltr?rtl|lang|xml::lang|onclick|ondblclick|"
                + "onmousedown|onmouseup|onmouseover|onmousemove|onmouseout|onkeypress|"
                + "onkeydown|onkeyup],a[rel|rev|charset|hreflang|tabindex|accesskey|type|"
                + "name|href|target|title|class|onfocus|onblur],strong/b,em/i,strike,u,"
                + "#p,-ol[type|compact],-ul[type|compact],-li,br,img[longdesc|usemap|"
                + "src|border|alt=|title|hspace|vspace|width|height|align],-sub,-sup,"
                + "-blockquote,-table[border=0|cellspacing|cellpadding|width|frame|rules|"
                + "height|align|summary|bgcolor|background|bordercolor],-tr[rowspan|width|"
                + "height|align|valign|bgcolor|background|bordercolor],tbody,thead,tfoot,"
                + "#td[colspan|rowspan|width|height|align|valign|bgcolor|background|bordercolor"
                + "|scope],#th[colspan|rowspan|width|height|align|valign|scope],caption,-div,"
                + "-span,-code,-pre,address,-h1,-h2,-h3,-h4,-h5,-h6,hr[size|noshade],-font[face"
                + "|size|color],dd,dl,dt,cite,abbr,acronym,del[datetime|cite],ins[datetime|cite],"
                + "object[classid|width|height|codebase|*],param[name|value|_value],embed[type|width"
                + "|height|src|*],script[src|type],map[name],area[shape|coords|href|alt|target],bdo,"
                + "button,col[align|char|charoff|span|valign|width],colgroup[align|char|charoff|span|"
                + "valign|width],dfn,fieldset,form[action|accept|accept-charset|enctype|method],"
                + "input[accept|alt|checked|disabled|maxlength|name|readonly|size|src|type|value],"
                + "kbd,label[for],legend,noscript,optgroup[label|disabled],option[disabled|label|selected|value],"
                + "q[cite],samp,select[disabled|multiple|name|size],small,"
                + "textarea[cols|rows|disabled|name|readonly],tt,var,big",
              selector: "textarea",
              height: 600,
              plugins: [
                "advlist autolink lists link image charmap print preview hr anchor pagebreak",
                "searchreplace wordcount visualblocks visualchars code",
                "insertdatetime media nonbreaking save table contextmenu directionality",
                "emoticons template paste textcolor colorpicker textpattern imagetools codesample"
              ],
              content_css: ["content/bootstrap.min.css", "content/Supernice.css", "content/Site.css", "content/documentation.css"],
              toolbar1: 'undo redo | insert | styleselect | fontsizeselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
              toolbar2: 'print preview media | forecolor backcolor emoticons | codesample customHtml',
              fontsize_formats: '8pt 10pt 12pt 14pt 18pt 24pt 36pt',
              image_advtab: true,
              link_list: editableWebPageModelSelf.selectableProcessTypes,
              setup(editor) {
                editor.addButton('customHtml', {
                  text: 'Custom Html',
                  type: 'menubutton',
                  icon: false,
                  menu: [
                    {
                      text: 'Styled Button',
                      onclick() {
                        editor.insertContent('<a class="btn btn-primary" title="Custom" href="#/home">Custom</a>');
                      }
                    }
                  ]
                });
              }
            };
          });
        });
    }

    updateContentPage() {
      editableWebPageModelSelf.editableContentPageService.updateEditableContentPage(editableWebPageModelSelf.editableContentPageDto);
    }
  }
}